const actionTypes = Object.freeze({
  //app
  APP_START_UP_COMPLETE: "APP_START_UP_COMPLETE",
  SET_CONTENT_OF_CONFIRM_MODAL: "SET_CONTENT_OF_CONFIRM_MODAL",
  CHANGE_LANGUAGE: "CHANGE_LANGUAGE",

  //user
  ADD_USER_SUCCESS: "ADD_USER_SUCCESS",
  USER_LOGIN_SUCCESS: "USER_LOGIN_SUCCESS",
  USER_LOGIN_FAIL: "USER_LOGIN_FAIL",
  PROCESS_LOGOUT: "PROCESS_LOGOUT",

  // admin
  FETCH_GENDER_START: "FETCH_GENDER_START",
  FETCH_GENDER_SUCCESS: "FETCH_GENDER_SUCCESS",
  FETCH_GENDER_FAILED: "FETCH_GENDER_FAILED",

  FETCH_POSITION_SUCCESS: "FETCH_POSITION_SUCCESS",
  FETCH_POSITION_FAILED: "FETCH_POSITION_FAILED",

  FETCH_ROLE_SUCCESS: "FETCH_ROLE_SUCCESS",
  FETCH_ROLE_FAILED: "FETCH_ROLE_FAILED",

  CREATE_USER_SUCCESS: "CREATE_USER_SUCCESS",
  CREATE_USER_FAILED: "CREATE_USER_FAILED",

  EDIT_USER_SUCCESS: "EDIT_USER_SUCCESS",
  EDIT_USER_FAILED: "EDIT_USER_FAILED",

  DELETE_USER_SUCCESS: "DELETE_USER_SUCCESS",
  DELETE_USER_FAILED: "DELETE_USER_FAILED",

  FETCH_ALL_USERS_SUCCESS: "FETCH_ALL_USERS_SUCCESS",
  FETCH_ALL_USERS_FAILED: "FETCH_ALL_USERS_FAILED",

  FETCH_TOP_BARBERS_SUCCESS: "FETCH_TOP_BARBERS_SUCCESS",
  FETCH_TOP_BARBERS_FAILED: "FETCH_TOP_BARBERS_FAILED",

  FETCH_ALL_BARBERS_SUCCESS: "FETCH_ALL_BARBERS_SUCCESS",
  FETCH_ALL_BARBERS_FAILED: "FETCH_ALL_BARBERS_FAILED",

  SAVE_DETAIL_BARBER_SUCCESS: "SAVE_DETAIL_BARBER_SUCCESS",
  SAVE_DETAIL_BARBER_FAILED: "SAVE_DETAIL_BARBER_FAILED",

  FETCH_ALLCODE_SCHEDULE_TIME_SUCCESS: "FETCH_ALLCODE_SCHEDULE_TIME_SUCCESS",
  FETCH_ALLCODE_SCHEDULE_TIME_FAILED: "FETCH_ALLCODE_SCHEDULE_TIME_FAILED",

  FETCH_REQUIRED_BARBER_INFOR_START:'FETCH_REQUIRED_BARBER_INFOR_START',
  FETCH_REQUIRED_BARBER_INFOR_SUCCESS: "FETCH_REQUIRED_BARBER_INFOR_SUCCESS",
  FETCH_REQUIRED_BARBER_INFOR_FAILED: "FETCH_REQUIRED_BARBER_INFOR_FAILED",
});

export default actionTypes;
